import styled from '@emotion/styled';
import { CircularProgress } from '@material-ui/core';
import { createElement, FC } from 'react';

import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Length = string | number;

type Props = {
  width?: Length;
  height?: Length;
  size?: Length;
  color?: 'primary' | 'secondary' | 'inherit';
  fullHeight?: boolean;
  className?: string;
};

const Spinner: FC<Props> = ({ width = '100%', height = 80, size = 32, color, fullHeight = false, className }) => (
  <Root fullHeight={fullHeight} width={width} height={height} className={className}>
    <div>
      <CircularProgress size={size} color={color} />
    </div>
  </Root>
);

const Root = styled('div')<Props>`
  ${flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  })}
  width: ${({ width }) => width}px;
  height: ${({ fullHeight, height }) => (fullHeight ? '100vh' : `${height}px`)};
  line-height: 0;
`;

export default Spinner;
